import axios from 'axios'

export function getFunctionInfo(data) {
    return axios({
        method: 'get',
        url: '/user/SysFunction',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function addFunctionInfo(data) {
    return axios({
        method: 'post',
        url: '/user/SysFunction',
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function editFunctionInfo(data) {
    return axios({
        method: 'put',
        url: '/user/SysFunction',
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function delFunctionInfo(data) {
    return axios({
        method: 'delete',
        url: '/user/SysFunction/' + data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function getFunctionUser(id, data) {
    return axios({
        method: 'get',
        url: '/user/SysFunction/user/' + id,
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

export function getFunctionRole(id, data) {
    return axios({
        method: 'get',
        url: '/user/SysFunction/role/' + id,
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    })
}

